import { Button, Icon, Tooltip, useAppShellTheme } from '../index';

const ToggleButton = () => {
  const { isNavbarVerticalCollapsed, setConfig } = useAppShellTheme();

  const handleClick = () => {
    const newState = !isNavbarVerticalCollapsed;
    document
      .getElementsByTagName('html')[0]
      .classList.toggle('navbar-vertical-collapsed');

    setConfig('isNavbarVerticalCollapsed', newState);
  };

  return (
    <Tooltip label='Toggle Navigation'>
      <div className='toggle-icon-wrapper d-none d-xl-inline'>
        <Button id='toggle-menu' variant='link' onClick={handleClick}>
          <Icon
            icon={isNavbarVerticalCollapsed ? 'closed-burger' : 'opened-burger'}
          />
        </Button>
      </div>
    </Tooltip>
  );
};

export default ToggleButton;
